var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFoxifyDocs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 2.333 11.375 L 2.333 2.625 C 2.333 1.82 2.986 1.167 3.792 1.167 L 11.667 1.167 L 11.667 12.833 L 3.792 12.833 C 2.986 12.833 2.333 12.18 2.333 11.375 C 2.333 10.57 2.986 9.917 3.792 9.917 L 11.667 9.917",
    fill: "transparent",
    strokeWidth: 1.1666666666666667,
    stroke: "rgb(179, 179, 179)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoxifyDocs);
export default __webpack_public_path__ + "static/media/FoxifyDocs.d0dffeaef1dfc44f831668f8cdc229ce.svg";
export { ForwardRef as ReactComponent };